<template>
    <div style="display: flex; justify-content: space-evenly">
        <div id="PasswortAendern" style="width:500px;overflow:auto">
            <h2>{{ $t('changepassword.Title') }}</h2>
            <fieldset>
                <legend>{{ $t('changepassword.GroupDataCollection') }}</legend>
                <br />
                <div class="mb-3">
                    <span>{{ $t('changepassword.LabelEMail') }}</span>
                    <k-input v-model="eMail"
                             :disabled="true"
                             :type="'email'"
                             :required='true'
                             :placeholder="$t('changepassword.LabelEMailPlaceholder')" />
                </div>
                <br />
                <div class="mb-3">
                    <span>{{ $t('changepassword.LabelPassword') }}</span>
                    <k-input v-model="passwortAktuell"
                             :type="'password'"
                             :required='true'
                             :placeholder="$t('changepassword.LabelPasswordPlaceholder')" />
                </div>
                <br />
                <div class="mb-3">
                    <span>{{ $t('changepassword.LabelNewPassword') }}</span>
                    <k-input v-model="passwortNeu"
                             :type="'password'"
                             :required='true'
                             :placeholder="$t('changepassword.LabelNewPasswordPlaceholder')" />
                </div>
                <br />
                <div class="mb-3">
                    <span>{{ $t('changepassword.LabelRepeatNewPassword') }}</span>
                    <k-input v-model="passwortWiederholen"
                             :type="'password'"
                             :required='true'
                             :placeholder="$t('changepassword.LabelRepeatNewPasswordPlaceholder')" />
                </div>
                <br />
            </fieldset>
            <fieldset>
                <legend>{{ $t('changepassword.GroupDataDescription') }}</legend>
                <span>{{ $t('changepassword.GroupDataDescriptionDetails') }}</span>
            </fieldset>
            <div class="text-right">
                <kbutton :theme-color="'primary'" @click="onSaveClick">{{ $t('changepassword.ButtonSave') }}</kbutton>
            </div>
            <NotificationGroup :style="{
            bottom: 0,
            left: '50%',
            transform: 'translateX(-50%)',
            'align-items': 'flex-start'
            }">
                <Fade :appear="successPasswortAendern">
                    <Notification v-if="successPasswortAendern" :type="{ style: 'success', icon: true }">
                        <span>{{ $t('changepassword.NotificationVerificationSuccess') }}</span>
                    </Notification>
                </Fade>
                <Fade :appear="errorPasswortAktuell">
                    <Notification v-if="errorPasswortAktuell" :type="{ style: 'error', icon: true }">
                        <span>{{ $t('changepassword.NotificationVerificationNotMatch') }}</span>
                    </Notification>
                </Fade>
                <Fade :appear="errorPasswortNeuWiederholen">
                    <Notification v-if="errorPasswortNeuWiederholen" :type="{ style: 'error', icon: true }">
                        <span>{{ $t('changepassword.NotificationVerificationNotMatchRepeated') }}</span>
                    </Notification>
                </Fade>
                <Fade :appear="errorPasswortNeuGleichAktuell">
                    <Notification v-if="errorPasswortNeuGleichAktuell" :type="{ style: 'error', icon: true }">
                        <span>{{ $t('changepassword.NotificationVerificationNotMatchCurrent') }}</span>
                    </Notification>
                </Fade>
                <Fade :appear="errorPflichtfelder">
                    <Notification v-if="errorPflichtfelder" :type="{ style: 'error', icon: true }">
                        <span>{{ $t('changepassword.NotificationVerificationMandatoryFields') }}</span>
                    </Notification>
                </Fade>
                <Fade :appear="errorPasswortNeuZuKurz">
                    <Notification v-if="errorPasswortNeuZuKurz" :type="{ style: 'error', icon: true }">
                        <span>{{ $t('changepassword.NotificationVerificationTooShort') }}</span>
                    </Notification>
                </Fade>
                <Fade :appear="errorPasswortNeuNichtKomplex">
                    <Notification v-if="errorPasswortNeuNichtKomplex" :type="{ style: 'error', icon: true }">
                        <span>{{ $t('changepassword.NotificationVerificationNotComplex') }}</span>
                    </Notification>
                </Fade>
            </NotificationGroup>
            <br />
        </div>
    </div>
</template>

<script>
    import { Input } from '@progress/kendo-vue-inputs';
    import { Button } from '@progress/kendo-vue-buttons';
    import sha512 from 'crypto-js/sha512';
    import axios from 'axios';
    import config from "@/appdata/config.json";
    import '@progress/kendo-ui';
    import '@progress/kendo-theme-default/dist/all.css';
    import store from '@/store/store.js';
    import { Fade } from '@progress/kendo-vue-animation';
    import { Notification, NotificationGroup } from '@progress/kendo-vue-notification';

    export default {
        components: {
            'kbutton': Button,
            'k-input': Input,
            Fade,
            Notification,
            NotificationGroup,
            store,
        },
        name: 'Home',
        props: {
            msg: String,
            menuClicked: false,
        },
        computed: {
            
        },
        data: function () {
            return {
                passwortAktuell: '',
                passwortNeu: '',
                passwortWiederholen: '',
                eMail: '',
                refBenutzer: 0,
                patchurl: '',
                successPasswortAendern: false,
                errorPasswortAendern: false,
                errorPasswortAktuell: false,
                errorPflichtfelder: false,
                errorPasswortNeuWiederholen: false,
                errorPasswortNeuGleichAktuell: false,
                errorPasswortNeuZuKurz: false,
                errorPasswortNeuNichtKomplex: false,
                success: false,
                error: false,
                numUpper: 0,
                numNumbers: 0,
                numSymbols: 0,
                i: 0
            }
        },
        created() {
            this.patchurl = config[0].ServiceUrl + config[0].ServiceUrlPort + "/UpdateBenutzerPasswort"
            this.getUserData();
        },
        methods: {
            onSaveClick() {
                this.errored = false;
                //Sind alle Felder ausgef�llt?
                if (this.passwortAktuell != '' && this.passwortNeu != '' && this.passwortWiederholen != '') {
                    //Pr�fung, ob aktuelles Passwort passt
                    const crypted = sha512(this.passwortAktuell).toString();
                    axios.get(config[0].ServiceUrl + config[0].ServiceUrlPort + '/LoginCheck', {
                        params: {
                            EMail: this.eMail,
                            Passwort: crypted
                        }
                    })
                        .then((response) => {
                            const loginStatus = response.data[0].checkStatus.toString();
                            if (loginStatus === '1') {
                                //Pr�fung ob neues Passwort und neues Passwort gleich sind
                                if (this.passwortWiederholen === this.passwortNeu) {
                                    //Pr�fung ob Passwort anders ist als das vorherige
                                    if (this.passwortNeu !== this.passwortAktuell) {
                                        //Pr�fung ob Passwort den Richtlinien entsprechen - L�nge > 11
                                        if (this.passwortNeu.length > 11) {
                                            //Pr�fung ob Passwort den Richtlinien entsprechen - L�nge > 11
                                            for (this.i = 0; this.i < this.passwortNeu.length; this.i++) {
                                                if (this.passwortNeu[this.i].match(/[A-Z]/g)) { this.numUpper++; }
                                                if (this.passwortNeu[this.i].match(/[0-9]/g)) { this.numNumbers++; }
                                                if (this.passwortNeu[this.i].match(/(.*[!,@,#,$,%,^,&,*,?,_,~,",�,%,&,/,\\,(,),=,{,},+,',-,.,:,;,<,>,|])/)) { this.numSymbols++; }
                                            }
                                            if (this.numUpper && this.numNumbers && this.numSymbols) {
                                                //Neues Passwort speichern
                                                const cryptedNew = sha512(this.passwortNeu).toString();
                                                const parameters = {
                                                    "prim": this.refBenutzer,
                                                    "passwort": cryptedNew,
                                                };
                                                axios.patch(this.patchurl, parameters)
                                                    .then((response) => {
                                                        console.log("----------> success", response);
                                                        this.showNotificationSuccessPasswortAendern();
                                                    })
                                                    .catch((error) => {
                                                        console.log("----------> error", error);
                                                        this.showNotificationErrorPasswortAendern();
                                                    });
                                            } else {
                                                this.showNotificationErrorPasswortNeuNichtKomplex();
                                            }
                                        } else {
                                            this.showNotificationErrorPasswortNeuZuKurz();
                                        }
                                    } else {
                                        this.showNotificationErrorPasswortNeuGleichAktuell();
                                    }
                                } else {
                                    this.showNotificationErrorPasswortNeuWiederholen();
                                }
                            } else {
                                this.showNotificationErrorPasswortAktuell();
                            }
                        })
                        .catch(error => {
                            console.log(error)
                            this.errored = true
                        })
                } else {
                    this.showNotificationErrorPflichtfelder();
                }
                
            },
            getUserData() {
                this.eMail = store.eMail;
                this.refBenutzer = store.refBenutzer;
            },
            showNotificationSuccessPasswortAendern() {
                /*Meldung anzeigen*/
                this.successPasswortAendern = true;
                /*Meldung automatisch ausblenden*/
                setTimeout(() => {
                    this.successPasswortAendern = false;
                }, 3000);
            },
            showNotificationErrorPasswortAendern() {
                /*Meldung anzeigen*/
                this.errorPasswortAendern = true;
                /*Meldung automatisch ausblenden*/
                setTimeout(() => {
                    this.errorPasswortAendern = false;
                }, 3000);
            },
            showNotificationErrorPflichtfelder() {
                /*Meldung anzeigen*/
                this.errorPflichtfelder = true;
                /*Meldung automatisch ausblenden*/
                setTimeout(() => {
                    this.Pflichtfelder = false;
                }, 3000);
            },
            showNotificationErrorPasswortAktuell() {
                /*Meldung anzeigen*/
                this.errorPasswortAktuell = true;
                /*Meldung automatisch ausblenden*/
                setTimeout(() => {
                    this.errorPasswortAktuell = false;
                }, 3000);
            },
            showNotificationErrorPasswortNeuWiederholen() {
                /*Meldung anzeigen*/
                this.errorPasswortNeuWiederholen = true;
                /*Meldung automatisch ausblenden*/
                setTimeout(() => {
                    this.errorPasswortNeuWiederholen = false;
                }, 3000);
            },
            showNotificationErrorPasswortNeuGleichAktuell() {
                /*Meldung anzeigen*/
                this.errorPasswortNeuGleichAktuell = true;
                /*Meldung automatisch ausblenden*/
                setTimeout(() => {
                    this.errorPasswortNeuGleichAktuell = false;
                }, 3000);
            },
            showNotificationErrorPasswortNeuZuKurz() {
                /*Meldung anzeigen*/
                this.errorPasswortNeuZuKurz = true;
                /*Meldung automatisch ausblenden*/
                setTimeout(() => {
                    this.errorPasswortNeuZuKurz = false;
                }, 3000);
            },
            showNotificationErrorPasswortNeuNichtKomplex() {
                /*Meldung anzeigen*/
                this.errorPasswortNeuNichtKomplex = true;
                /*Meldung automatisch ausblenden*/
                setTimeout(() => {
                    this.errorPasswortNeuNichtKomplex = false;
                }, 3000);
            },
        }
    };
</script>

<style scoped>
</style>